import type {
  AssetDetail,
  AssetDetailMeta,
  AssetMarker,
  UseGetAssetOptions,
} from "./asset.type";

import { useGet } from "@/hooks/queries";

export const useGetAsset = (
  assetId?: number | string,
  options?: UseGetAssetOptions
) => {
  const { data, meta, ...queryResult } = useGet<AssetDetail, AssetDetailMeta>(
    "assets",
    assetId,
    options
  );

  return {
    asset: data,
    context: meta?.context,
    ...queryResult,
  };
};

/**
 * @deprecated
 * This hook is deprecated and will be removed in the future.
 * It will be replaced by another endpoint to fetch markers independently from assets.
 */
export const useGetAssetMarkers = (assetId?: number | string) => {
  const { data, ...queryResult } = useGet<AssetMarker[]>("assets", assetId, {
    endPoint: "coordinates",
  });

  return {
    markers: data,
    ...queryResult,
  };
};
